import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const useFormGroupStyles = makeStyles({
  root: {
    maxWidth: '75%',
    padding: '16px 24px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

const useFormControlLabelStyles = makeStyles({
  label: {
    fontWeight: 500,
    fontSize: '1.25rem',
  },
});

const Checkboxes = ({ options, questionId, onSet, onRemove }) => {
  const formGroupClasses = useFormGroupStyles();
  const formControlLabelStyles = useFormControlLabelStyles();

  const [optionsState, setOptionsState] = useState(
    options
      .map(({ answerId }) => ({ [answerId]: false }))
      .reduce((prev, current) => {
        return { ...prev, ...current };
      }, {}),
  );
  const handleChage = event => {
    const answerId = event.target.value;
    const currentValue = !optionsState[answerId];

    setOptionsState({
      ...optionsState,
      [answerId]: currentValue,
    });

    if (currentValue) {
      onSet(questionId, answerId);
      return;
    }

    onRemove(answerId);
  };

  const formFields = options.map(({ answerLabel, answerId }) => {
    return (
      <FormControlLabel
        classes={formControlLabelStyles}
        control={<Checkbox checked={optionsState[answerId]} value={answerId} />}
        key={answerId}
        label={answerLabel}
        onChange={handleChage}
      />
    );
  });

  return (
    <FormGroup classes={formGroupClasses} row>
      {formFields}
    </FormGroup>
  );
};

Checkboxes.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      answerId: PropTypes.number.isRequired,
      answerLabel: PropTypes.string.isRequired,
      type: PropTypes.string,
    }),
  ).isRequired,
  questionId: PropTypes.number.isRequired,
  onSet: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export { Checkboxes };
